import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const shareApi = {
    //發送名片分享郵件
    "sendMemberworkShareEmail": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}Share/sendMemberworkShareEmail`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                email: null,
                url: null,
                content: null,
                userId: null,
                img: null
            }
        }
    },
    //發送店鋪分享郵件
    "sendShopShareEmail": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}Share/sendShopShareEmail`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                email: null,  //接收郵箱
                url: null,  //分享鏈接
                content: null,  //文字內容
                userId: null,  //分享者id
            }
        }
    }
}

export default shareApi